import PropTypes from 'prop-types';
import React from 'react';

import Button from 'material-ui/Button';
import Checkbox from 'material-ui/Checkbox';
import Dialog, {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from 'material-ui/Dialog';
import { FormControlLabel } from 'material-ui/Form';

export class DeleteCoreDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteMirror: false
    }
  }

  toggleDeleteMirror() {
    this.setState({
      deleteMirror: !this.state.deleteMirror
    });
  }

  handleConfirm() {
    const { deleteMirror } = this.state;
    this.props.handleConfirm({ deleteMirror });
  }
  
  render() {
    const {
      belowOrAvobe,
      open,
      handleClose,
      displayName,
      mirrorCore
    } = this.props;
    const { deleteMirror } = this.state;
    const toggleDeleteMirror = this.toggleDeleteMirror.bind(this);
    const handleConfirm = this.handleConfirm.bind(this);
    const mirrorLabel = mirrorCore
      ? `Delete the core, ${mirrorCore.displayName}, at the mirror layer, too`
      : '';

    return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-delete-core"
      >
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure to remove {displayName} and the prepreg{' '}
            {belowOrAvobe} from your stackup.
          </DialogContentText>
          {mirrorCore ? (
            <FormControlLabel
              control={
                <Checkbox
                  checked={deleteMirror}
                  onChange={toggleDeleteMirror}
                  value="mirror"
                />
              }
              label={mirrorLabel}
            />
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button variant="raised" onClick={handleClose}>
            No, it was a mistake
          </Button>
          <Button variant="raised" onClick={handleConfirm} color="secondary">
            Yes, I am sure
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

 DeleteCoreDialog.propTypes = {
   displayName: PropTypes.string,
   belowOrAvobe: PropTypes.string,
   open: PropTypes.bool,
   handleClose: PropTypes.func,
   handleConfirm: PropTypes.func,
   mirrorCore: PropTypes.object,
 };

 export default DeleteCoreDialog;


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/MenuDrawer/DeleteCoreDialog.js